import CloseIcon from '../../../assets/icons/close.svg?react';
import { useState } from 'react';
import { useUpdateCblModule } from '../../../hooks/queries/cblmoduleQueries';
import { useAuthContext } from '../../../contexts/AuthContext';
const CblModuleUpdateModal = ({ isOpen, onClose, target, onSuccess }) => {
  const { user } = useAuthContext();
  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState(null);
  const [cblModuleAppendObject, setCblModuleAppendObject] = useState({
    moduleName: target.ModuleName,
    version: target.Version,
    baseUrl: target.BaseUrl,
    modifierSysId: user.UserSysId,
  });
  const updateCblModule = useUpdateCblModule();
  if (!isOpen) return null;
  const handleUpdateCblModule = async () => {
    try {
      setIsPending(true);
      await updateCblModule.mutateAsync({ cblModuleSysId: target.CblModuleInfoSysId, payload: cblModuleAppendObject });
      onSuccess();
    } catch (error) {
      console.error('CBL 모듈 수정 실패:', error);
      setError('CBL 모듈 수정에 실패했습니다.');
    } finally {
      setIsPending(false);
    }
  };

  const handleChangeInput = (e) => {
    setCblModuleAppendObject({ ...cblModuleAppendObject, [e.target.name]: e.target.value });
  };
  return (
    <div className="side-modal-background">
      <div className="side-modal-container">
        <div className="side-modal-header">
          <h3>CBL 모듈 수정</h3>
          <button className="close-btn" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="modal-content flex flex-col gap-10 px-20 pt-10">
          <div className="flex flex-col gap-10">
            <div className="flex flex-col gap-2">
              <label htmlFor="moduleName" className='text-b2-400 text-gray-800'>모듈명</label>
              <input type="text" id="moduleName" name="moduleName" className='w-full input-primary' placeholder='모듈명을 입력해주세요.' value={cblModuleAppendObject.moduleName} onChange={handleChangeInput} />
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <label htmlFor="version" className='text-b2-400 text-gray-800'>버전</label>
            <input type="text" id="version" name="version" className='w-full input-primary' placeholder='버전을 입력해주세요.' value={cblModuleAppendObject.version} onChange={handleChangeInput} />
          </div>
          <div className="flex flex-col gap-2">
            <label htmlFor="baseUrl" className='text-b2-400 text-gray-800'>BaseUrl</label>
            <input type="text" id="baseUrl" name="baseUrl" className='w-full input-primary' placeholder='BaseUrl을 입력해주세요.' value={cblModuleAppendObject.baseUrl} onChange={handleChangeInput} />
          </div>
          <div className="mt-10">
            <button className="btn btn-primary big-btn w-full" onClick={handleUpdateCblModule} disabled={isPending || !cblModuleAppendObject.moduleName || !cblModuleAppendObject.version || !cblModuleAppendObject.baseUrl}>{isPending ? '수정 중...' : '수정'}</button>
          </div>
          {error && <div className="text-error">{error}</div>}
        </div>
      </div>
    </div>
  )
}

export default CblModuleUpdateModal